module.exports = __webpack_public_path__ + "img/image-empty.9e03bd9c.svg";